












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import BasicBadge from '@/components/BasicBadge.vue';
import FormatTime from '@/components/FormatTime.vue';
import TruncatedText from '@/components/TruncatedText.vue';
import { Conversation } from './type';

@Component({ components: { BasicBadge, FormatTime, TruncatedText } })
export default class ConversationList extends Vue {
  @Prop({ default: () => [] }) readonly conversations!: Conversation[];
}
